import React from 'react';
import CreatorSidebar from './CreatorSidebar';
import CreatorHeader from './CreatorHeader';

interface CreatorStudioLayoutProps {
  children: React.ReactNode;
}

const CreatorStudioLayout: React.FC<CreatorStudioLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-creator-bg dark:bg-gray-900">
      {/* Sidebar */}
      <CreatorSidebar />
      
      {/* Header */}
      <CreatorHeader />
      
      {/* Main Content Area */}
      <main className="ml-16 mt-16 h-[calc(100vh-4rem)]">
        {children}
      </main>
    </div>
  );
};

export default CreatorStudioLayout;
